import { TabOption } from '@/components/chariot-ui';
import type {
  MainTabKey,
  POEContent,
  SectionContent,
} from '@/sections/poe/types/poe.types';

import { parseWizData } from './wiz/parseWizData';
import {
  renderConfiguration,
  renderDataFindingPII,
  renderEndpoint,
  renderEndpointVuln,
  renderErrorFallback,
  renderFindingSummary,
  renderGenericResource,
  renderMultiSection,
  renderSecretData,
  renderSecretInstance,
  renderSecurityImpact,
  renderSimpleAttributes,
  renderSimpleVuln,
  renderSubscription,
  renderVulnDescription,
} from './wiz/renderers';
import type { WizRenderContext } from './wiz/types';

export const processWizDataSource = (
  poeData: POEContent,
  sections: Record<string, SectionContent>,
  tempTabs: Record<MainTabKey, TabOption[]>,
  mainTabKeys: MainTabKey[]
): string[] => {
  const sectionKeysBeforeWiz = new Set(Object.keys(sections));
  const tempTabsBeforeWiz = Object.fromEntries(
    (Object.keys(tempTabs) as MainTabKey[]).map(key => [
      key,
      [...tempTabs[key]],
    ])
  ) as Record<MainTabKey, TabOption[]>;

  try {
    const parsed = parseWizData(poeData);
    const ctx: WizRenderContext = { sections, tempTabs, mainTabKeys };

    renderSecretData(parsed, ctx);
    renderSecretInstance(parsed, ctx);
    renderDataFindingPII(parsed, ctx);
    renderMultiSection(parsed, ctx);
    renderConfiguration(parsed, ctx);
    renderSimpleVuln(parsed, ctx);
    renderSimpleAttributes(parsed, ctx);
    renderSubscription(parsed, ctx);
    renderEndpoint(parsed, ctx);
    renderVulnDescription(parsed, ctx);
    renderGenericResource(parsed, ctx);
    renderFindingSummary(parsed, ctx);
    renderSecurityImpact(parsed, ctx);
    renderEndpointVuln(parsed, ctx);

    return parsed.processedKeys;
  } catch {
    for (const key of Object.keys(sections)) {
      if (!sectionKeysBeforeWiz.has(key)) delete sections[key];
    }
    for (const key of Object.keys(tempTabsBeforeWiz) as MainTabKey[]) {
      tempTabs[key] = tempTabsBeforeWiz[key];
    }
    renderErrorFallback(poeData, sections, tempTabs, mainTabKeys);
    return [];
  }
};
